import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Avatar from 'Layout/Components/Avatar';

const Header = ({ isSidebarOpen, showAppName = false }) => {
  const currentUser = useSelector((state) => state.currentUser);

  return (
    <header className="header">
      <div className="nav-bar">
        <div className="navbar-left">
          {(!isSidebarOpen || showAppName) && (
            <div className="header-logo">
              <img src="/tui-icon.svg" alt="TUI Logo" width="28" height="28" />
              <span className="header-app-name">Fly2Work</span>
            </div>
          )}
        </div>
        <div className="navbar-center"></div>
        <div className="navbar-right">
          <span style={{ fontSize: '14px', color: '#666' }}>{currentUser?.email || ''}</span>
          <Avatar />
        </div>
      </div>
    </header>
  );
};

Header.propTypes = {
  isSidebarOpen: PropTypes.bool.isRequired,
  showAppName: PropTypes.bool,
};

export default Header;
